import { render } from "./PenyataPemungut.vue?vue&type=template&id=410298d4"
import script from "./PenyataPemungut.vue?vue&type=script&lang=js"
export * from "./PenyataPemungut.vue?vue&type=script&lang=js"

import "./PenyataPemungut.vue?vue&type=style&index=0&id=410298d4&lang=css"
import "./PenyataPemungut.vue?vue&type=style&index=1&id=410298d4&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__